import React, { useState, useEffect } from 'react';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import { translations } from './data/translations';
import './styles/App.css';

function App() {
  // Get initial language from URL parameter
  const getInitialLanguage = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const langParam = urlParams.get('lang');
    return langParam === 'fr' ? 'fr' : 'en'; // Default to English
  };

  const [language, setLanguage] = useState(getInitialLanguage());
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Update URL when language changes (optional)
  useEffect(() => {
    const url = new URL(window.location);
    url.searchParams.set('lang', language);
    window.history.replaceState({}, '', url);
  }, [language]);

  return (
    <div className="app">
      <NavBar
        language={language}
        setLanguage={setLanguage}
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
      />
      
      <HomePage
        translations={translations}
        language={language}
      />
      
      <Footer
        translations={translations}
        language={language}
      />
    </div>
  );
}

export default App;